import { ChangeEvent, useState } from 'react';

import Card from 'components/common/ui-kit/Card';
import Checkbox from 'components/common/ui-kit/Checkbox';
import useAppDispatch from 'hooks/common/useAppDispatch';
import useAppSelector from 'hooks/common/useAppSelector';
import terms from 'i18n';
import { createToast } from 'redux/actions';
import { applicationsApi } from 'redux/api/applications/applications-api';
import { selectApplication } from 'redux/selectors/enrollee/application';
import './contract-informing.scss';

type ContractInformingProps = {
  className?: string;
  disabled?: boolean;
};

export default function Informing(props: ContractInformingProps) {
  const application = useAppSelector(selectApplication);
  if (!application) {
    throw new Error();
  }
  const initialChecked = application.informing;
  const dispatch = useAppDispatch();
  const [isChecked, setIsChecked] = useState(initialChecked);
  const [isPrevChecked, setIsPrevChecked] = useState(initialChecked);
  const [update] = applicationsApi.useLazySetInformingQuery();

  if (isPrevChecked !== initialChecked) {
    setIsChecked(initialChecked);
    setIsPrevChecked(initialChecked);
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked;
    setIsChecked(newValue);
    update({
      applicationId: application?.id,
      informing: newValue,
    })
      .unwrap()
      .then(() => {
        dispatch(
          applicationsApi.util.updateQueryData(
            'getApplicationById',
            application.id,
            draft => {
              draft.informing = newValue;
            }
          )
        );
        dispatch(
          createToast(
            newValue
              ? terms.CONTRACT_INFORMING_PAID_PLACES
              : terms.CONTRACT_INFORMING_ENROLL_REVOKE,
            'success'
          )
        );
      })
      .catch(() => {
        setIsChecked(!newValue);
        dispatch(
          createToast(
            'Во время подтверждения информирования о необходимости зачисления произошла ошибка. Пожалуйста, попробуйте позже.',
            'danger'
          )
        );
      });
  };

  return (
    <Card title={terms.CONTRACT_INFORMING} required {...props}>
      <Checkbox
        checked={isChecked}
        onChange={handleChange}
        text={terms.CONTRACT_INFORMING_APPROVEMENT}
        disabled={props.disabled}
      />
      <p className="contract-informing__description">
        {terms.CONTRACT_INFORMING_DESCRIPTION}{' '}
        <b>{terms.CONTRACT_INFORMING_START_DATE}</b>
      </p>
    </Card>
  );
}
